import { Option } from '@storeblocks/radio';
import { getAppText } from 'Utils/text';
import { CancelReasonElectricScooter } from './cancelElectricScooterForm.types';

export const getElectricScooterCancellationOptions = (): Option[] => [
  {
    label: getAppText('cancel.electricScooter.cancelReason.option.sold'),
    value: CancelReasonElectricScooter.SOLD,
    id: 'cancelReason-1',
  },
  {
    label: getAppText('cancel.electricScooter.cancelReason.option.broken'),
    value: CancelReasonElectricScooter.BROKEN_AND_RECYCLED,
    id: 'cancelReason-2',
  },
];
